import AxiosManager from "./managers/AxiosManager";

export default class BaseService extends AxiosManager {

}